
import state from './actualSalesState.js'
import * as mutations from './actualSalesMutations.js'
import * as actions from './actualSalesActions.js'
import * as getters from './actualSalesGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}